angular.module('logbook')
.config(['uibDatepickerConfig', function(uibDatepickerConfig) {
   uibDatepickerConfig.showWeeks = false;
}]);